module.exports = __webpack_public_path__ + "static/media/1.bf41d086.png";